import React from 'react';
import { Row, Col } from 'react-bootstrap';

const InfoRow = ({ label, value }) => (
  <Row className="mb-2">
    <Col xs={5} className="text-muted">{label}:</Col>
    <Col xs={7}>{value}</Col>
  </Row>
);

export default InfoRow;